import { AICA_REPORT_ID } from '../../Reports/constants';

/**
 * Find the existing AICA Report doc (if any) among an assessee's saved
 * documents so a repeat PDF download can update that same row's lineage
 * instead of minting a fresh `id`/`genId` — which would otherwise leave one
 * more "AICA Report" row in the Reports list per download (RECUR-26249
 * review). Returns undefined fields when there's no prior entry (first
 * download for this assessee), so the caller's `saveDocument` payload spread
 * naturally omits `id`/`genId` and the backend mints the first row.
 */
export function resolveExistingAicaReportEntry(existingDocs: any[] | null | undefined): { id?: string; genId?: string } {
    const match = existingDocs?.find((doc) => doc?.documentType === AICA_REPORT_ID);
    return {
        id: match?._id ?? match?.id ?? match?.docId ?? undefined,
        genId: match?.genId ?? undefined,
    };
}
